/**
 * 路由配置
 */
import NProgress from 'nprogress';
import '@/assets/css/nprogress.scss'
import type { _RouteLocationBase } from 'vue-router';
import { createRouter, createWebHistory } from 'vue-router';
import { LOGIN_PATH, REDIRECT_PATH, LAYOUT_PATH } from '../config/setting';
import { setMeta, setPageTitle } from '../utils'
import { useUserStore, useMenuStore } from '../stores'
import { routes, getMenuRoutes, isWhiteList } from './routes'

NProgress.configure({
  speed: 200,
  minimum: 0.02,
  trickleSpeed: 200,
  showSpinner: false
});

const router = createRouter({
  routes,
  history: createWebHistory(),
  scrollBehavior: () => {
    return { top: 0 };
  }
});

/**
 * 添加 Dashboard 路由
 */
function addDashboardRoute(userStore) {
  if (router.hasRoute('Dashboard')) return;
  router.addRoute('Layout', {
    path: 'dashboard',
    name: 'Dashboard',
    component: () => import(`@/views/dashboard/index.vue`),
    meta: {
      title: '招生数据总览',
      icon: 'Dashboard',
      isHome: true,
    }
  });
}

/**
 * 加载动态路由
 */
async function loadDynamicRoutes(menuStore, userStore, to) {
  if (menuStore.initialized) return false;
  try {
    const menus = await menuStore.initializeMenuData();
    if (!menus || menus.length === 0) return false;
    // 添加菜单路由
    const dynamicRoutes = getMenuRoutes(menuStore.menus);
    dynamicRoutes.forEach((r) => {
      if (r.path !== '/' && !router.hasRoute(r.name)) {
        router.addRoute(r);
      }
    });
    // 添加首页路由
    addDashboardRoute(userStore);
    // 设置激活菜单（非 dashboard 页面）
    if (to && !to.path.includes('dashboard')) {
      menuStore.setActiveMenu(to.path);
    }
    menuStore.initialized = true;
    return true;
  } catch (error) {
    console.error('加载动态路由失败:', error);
    return false;
  }
}

/**
 * 路由守卫
 */
router.beforeEach(async (to) => {
  const userStore = useUserStore();
  const menuStore = useMenuStore();
  // 进度条和标题处理
  if (!to.path.includes(REDIRECT_PATH)) {
    NProgress.start();
    setMeta();
    setPageTitle(to.meta.title);
  }
  // 恢复用户状态
  if (!userStore.isLoggedIn) {
    userStore.restoreLoginState();
  }
  const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
  // 未登录处理
  if (!isLoggedIn) {
    if (isWhiteList(to.path)) {
      return true;
    }
    const query = { from: encodeURIComponent(to.fullPath) };
    return {
      path: LOGIN_PATH,
      query: to.path === LAYOUT_PATH ? {} : query
    };
  }
  // 访问登录页或根路径，重定向到首页
  if (to.path === LOGIN_PATH || to.path === '/') {
    await loadDynamicRoutes(menuStore, userStore);
    return '/layout/dashboard';
  }
  // 其他页面：确保动态路由已加载
  if (!menuStore.initialized) {
    const loaded = await loadDynamicRoutes(menuStore, userStore, to);
    if (loaded) {
      // 刷新当前路由
      return { ...to, replace: true };
    }
  }
  return true;
});
router.afterEach((to) => {
  if (!to.path.includes(REDIRECT_PATH) && NProgress.isStarted()) {
    setTimeout(() => {
      NProgress.done(true);
    }, 200);
  }
});
export default router;
